// Port of api/fuel/app/classes/insights/worth/band.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function worthFilter(filter) {
	return filter['valuations.expansions'] || filter.valuations || 'games'
}

export default Segment.extend({
	name: 'band',
	types: [Constants.TYPE_USER],
	insight: false,
	default_: false,
	detail: false,
	run: function(type, owner, userIndex, detail, filter, vars) {
		var band = parseInt(vars.band, 10)
		var selected = worthFilter(filter || {})
		var games = []
		var min = (band * 8) + 1
		var max = (band + 1) * 8

		var raw = Util.queryFast(
			'SELECT g.game_id AS g, COALESCE(NULLIF(v.game_version_worth_value, 0), g.game_worth_value, 0) AS w' +
			' FROM (collection c JOIN game g ON c.game_id = g.game_id)' +
			' LEFT JOIN game_version v ON v.game_version_id = c.game_version_id' +
			' WHERE c.user_id = ' + owner.get_id() +
			' AND c.collection_own = 1' +
			(selected !== 'all' ? (' AND c.collection_expansion = ' + (selected === 'games' ? 0 : 1)) : '') +
			' AND g.game_worth_value >= ' + min +
			(band !== 15 ? (' AND g.game_worth_value <= ' + max) : '') +
			' ORDER BY w ASC'
		)

		for (var i = 0; i < raw.length; i++) {
			var gameId = parseInt(raw[i].g, 10)
			this._references.games.push(gameId)
			games.push({
				id: gameId,
				worth: Math.floor(parseFloat(raw[i].w) || 0)
			})
		}

		return {
			games: games
		}
	}
})
